import { useEffect, useState } from "react";
import {
  getProductPrice,
  ProductPriceSchema,
} from "src/models/newProduct/getProductPrice";
import { useRouter } from "next/router";

export const useGetProductPrice = () => {
  const [productPriceData, setProductPriceData] =
    useState<ProductPriceSchema>();
  const [isLoadingPrice, setLoadingPrice] = useState<boolean>();
  const [error, setError] = useState(false);

  const router = useRouter();
  const citySlug = router.query.city;
  const productSlug = router.query.product;

  useEffect(() => {
    setLoadingPrice(true);
    if (typeof citySlug === "string" && typeof productSlug === "string") {
      getProductPrice({
        product_slug: productSlug,
        city_slug: citySlug,
      })
        .then((res) => setProductPriceData(res.data))
        .catch(() => setError(true))
        .finally(() => setLoadingPrice(false));
    }
  }, [citySlug, productSlug]);

  return { productPriceData, isLoadingPrice, error };
};
